import { Box } from "@mui/material";

interface Props {
}

interface ItemProps {
    children: React.ReactNode;
}

const Item = ({ children }: ItemProps) => {
    return (
        <Box
            sx={{
                p: 1,
                ml: 0.5,
                border: '1px solid',
                borderColor: 'grey.300',
                borderRadius: 1,
            }}
        >
            {children}
        </Box>
    );
};

export function ColorLegend(props: Props): React.JSX.Element {

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                bgcolor: 'background.paper',
                borderRadius: 1,
            }}
        >
            <Item>
                <div title="Latest data was available <3 hours ago.">
                    <div
                        style={{ height: "1rem", width: "1rem", borderRadius: "0.5rem", backgroundColor: "green", display: "inline-block", marginRight: "10px" }}
                    />
                    {"<3 hours"}
                </div>
            </Item>
            <Item>
                <div title="Latest data was available 3-12 hours ago.">
                    <div
                        style={{ height: "1rem", width: "1rem", borderRadius: "0.5rem", backgroundColor: "yellow", display: "inline-block", marginRight: "10px" }}
                    />
                    {"3-12 hours"}
                </div>
            </Item>
            <Item>
                <div title="Latest data was available >12 hours ago.">
                    <div
                        style={{ height: "1rem", width: "1rem", borderRadius: "0.5rem", backgroundColor: "red", display: "inline-block", marginRight: "10px" }}
                    />
                    {">12 hours"}
                </div>
            </Item>
                    
        </Box>
    );
}